export default __webpack_public_path__ + "static/media/ill-no-data.a95ead3d.svg";